export const DEVICE_STATUS = {
  ONLINE: 'online',
  STANDBY: 'standby',
  OFFLINE: 'offline'
}
